import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const assetIssueByItemTodo = createAsyncThunk('assetIssueByItem', async ({ itemId, categoryId, subCategoryId, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `unissued_asset_details`,
            params: {
                item_master_id: itemId,
                category_id: categoryId,
                sub_cat_id: subCategoryId
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const assetIssueByItemSlice = createSlice({
    name: 'assetIssueByItem',
    initialState: {
        data: [],
    },
    reducers: {
        removeItems: (state, action) => {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(assetIssueByItemTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }


        });
        builder.addCase(assetIssueByItemTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export const { removeItems } = assetIssueByItemSlice.actions;
export default assetIssueByItemSlice.reducer; 